(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-constants/assets/javascripts/api-paths.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-constants/assets/javascripts/api-paths.js');

'use strict';

let productMapping;
if (svs.isServer) {
  productMapping = require('./product-mapping.es6');
} else {
  productMapping = svs.lyckoplatsen.components.shared_constants.productMapping;
}
const {
  CONSTANTS: {
    LYCKOPLATSEN,
    LYCKOPLATSEN_PRIMARY,
    LYCKOPLATSEN_SECONDARY
  },
  getProductWagersId,
  getProductDrawId
} = productMapping;
const isDefined = value => value !== undefined && value !== null;
const isArray = value => Array.isArray(value);
const isObject = value => isDefined(value) && !isArray(value) && typeof value === 'object';
function getQuery(queries, key) {
  if (isObject(queries)) {
    queries = Object.entries(queries);
  } else if (isArray(queries)) {
    queries = queries.map(value => [key, value]);
  } else {
    queries = [[key, queries]];
  }
  queries = queries.map(query => query.filter(q => isDefined(q)).join('='));
  return queries.length ? "?".concat(queries.join('&')) : '';
}

const primaryDraw = () => "/draw/1/".concat(getProductDrawId(LYCKOPLATSEN_PRIMARY), "/draws");
const primaryDrawByDrawNumber = drawNumber => "/draw/1/".concat(getProductDrawId(LYCKOPLATSEN_PRIMARY), "/draws/").concat(drawNumber);
const primaryResultByDrawNumber = drawNumber => "/draw/1/".concat(getProductDrawId(LYCKOPLATSEN_PRIMARY), "/draws/").concat(drawNumber, "/result");
const secondaryDraw = () => "/draw/1/".concat(getProductDrawId(LYCKOPLATSEN_SECONDARY), "/draws");
const secondaryDrawByDrawNumber = drawNumber => "/draw/1/".concat(getProductDrawId(LYCKOPLATSEN_SECONDARY), "/draws/").concat(drawNumber);
const secondaryResultByDrawNumber = drawNumber => "/draw/1/".concat(getProductDrawId(LYCKOPLATSEN_SECONDARY), "/draws/").concat(drawNumber, "/result");
const result = () => "/draw/1/".concat(getProductDrawId(LYCKOPLATSEN), "/draws/result");
const resultsBySpan = days => "/draw/1/".concat(getProductDrawId(LYCKOPLATSEN), "/draws/result/byspan?days=_").concat(days);
const datePicker = (year, month) => "/draw/1/results/datepicker?product=".concat(getProductDrawId(LYCKOPLATSEN), "&year=").concat(year, "&month=").concat(month);
const drawByDrawId = (product, drawNumber) => "/draw/1/".concat(getProductDrawId(product), "/draws/").concat(drawNumber);
const resultByDrawId = (product, drawNumber) => "/draw/1/".concat(getProductDrawId(product), "/draws/").concat(drawNumber, "/result");

const charities = () => '/charity/1/externalcharities';
const charityById = charityId => "/charity/1/externalcharities/".concat(charityId);
const charityPayouts = () => '/charity/1/payoutstatistics';
const charityPayoutsByDraws = drawNumbers => "/charity/1/payoutstatistics".concat(getQuery(drawNumbers, 'drawIds'));

const activeWagers = () => "/player/1/wagers?status=Active&productId=".concat(getProductWagersId(LYCKOPLATSEN));
const wagerIdsByDraw = (product, drawNumber) => "/customerbet/1/wager/by/draw?product=".concat(getProductWagersId(product), "&drawNumber=").concat(drawNumber);
const wagerById = wagerId => "/player/1/wagers/".concat(wagerId);
const wagerByToken = accessToken => "/cache/2/tokens/".concat(accessToken);

const address = customerId => "/player/2/address?customerId=".concat(customerId);
const addressGeoLocation = () => "/player/1/preferences/30/key?preferenceKey=addressGeoLocation";

const subscriptionById = subscriptionId => "/player/1/subscription?subscription=".concat(subscriptionId);
const activeSubscriptions = () => '/player/1/activesubscriptions';
const changeSubscriptionCharity = () => "/subscription/2/selectcharity";

const selectCharity = () => '/geo/2/selectcharity';
const API_PATHS = {
  primaryDraw,
  primaryDrawByDrawNumber,
  primaryResultByDrawNumber,
  secondaryDraw,
  secondaryDrawByDrawNumber,
  secondaryResultByDrawNumber,
  result,
  resultsBySpan,
  datePicker,
  drawByDrawId,
  resultByDrawId,
  charities,
  charityById,
  charityPayouts,
  charityPayoutsByDraws,
  activeWagers,
  wagerIdsByDraw,
  wagerByToken,
  wagerById,
  address,
  addressGeoLocation,
  selectCharity,
  subscriptionById,
  activeSubscriptions,
  changeSubscriptionCharity
};
if (svs.isServer) {
  module.exports = API_PATHS;
} else {
  Object.assign(svs.lyckoplatsen.components.shared_constants, {
    API_PATHS
  });
}

 })(window);